<template>
  <PageContent>
    <StepsV2 :step="4" />
    <PanelV2
      type="w6"
      title="Upload your DTI Certificate"
      @nextClick="commitData()"
    >
      <template v-slot:title-solt>
        <BdoProgress  :step="2" :total="3" />
      </template>
      <template v-slot:content-solt>
        <IdCardUpload photoType="DTI" @ditImg="ditImg" :photoData="formData" />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  // import AppForm from "../forms/ExistingBDOMerchant.val";
  import IdCardUpload from "../pages/common/IdCardUpload.vue";
  import API from "@/api";

  export default {
    name: 'SolePropK',
    pRouter: 'SolePropJ',
    components: {
      IdCardUpload,
      // AppForm,
    },
    data() {
      return {
        formData: { dtiUrl: '' },
      }
    },
    methods: {
      ditImg(val) {
        this.formData.dtiUrl = val;
      },
      commitData() {

        // this.$refs.appForm.$refs.appForm.validate((valid) => {

          if (this.formData.dtiUrl) {
            const data = this.formatCommitData({...this.formData})

            API.addBdoProcess({
              ...data
            }).then(res => {
              if (res.success) {
                this.toNext()
              }
            })
          } else {
            this.showMessageTip('The picture does not support empty ')
          }
        // });
      }
    }
  }
</script>


<style lang="scss" scoped>

</style>
